// URL function type - can take any number of arguments and returns a URL string
type URLFunction = (...args: any[]) => string;

// Formatter function type - takes API response and returns processed value
type FormatterFunction = ((response: any) => any) | undefined;

// HTTP method type
type HTTPMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

// API registry entry
interface APIEntry {
  urlFunction: URLFunction;
  formatter: FormatterFunction;
  method: HTTPMethod;
}

const apis: Record<string, APIEntry> = {};

export function registerAPI(
  apiName: string,
  urlFunction: URLFunction,
  formatter: FormatterFunction,
  method: HTTPMethod = "GET"
): APIEntry {
  apis[apiName] = {
    urlFunction,
    formatter,
    method,
  };
  return apis[apiName];
}

export function getAPI(apiName: string): APIEntry | undefined {
  return apis[apiName];
}
